import RelancesTab from "@features/comptabilite/components/relances/RelancesTab";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { AlertTriangle } from "lucide-react";

export const Route = createFileRoute("/_app/comptabilite/relances/")({
  staticData: {
    title: "Relances",
    icon: AlertTriangle,
    tab_icon: AlertTriangle,
    permission: PERMISSIONS.COMPTABILITE.RELANCES.VIEW,
    module: "comptabilite",
    order: 50,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: RelancesTab,
});
